<template>
    <div class="menu-item" v-if="showDropdown" :open="isOpen" v-on:mouseover="isMobile ? null : isOpen = true"
        v-on:mouseleave="isMobile ? null : isOpen = false" @click="toogleSubMenu(option)">
        <span class="title" :active="isOpen">
            <router-link class="flex" :to="'/' + $i18n.locale + '/' + $t('enlaces.' + option)">
                {{ $t(`enlaces.textos.${option}`) }}
                <div v-if="option == 'area_tecnica' && $store.state.currentTips.length > 0" class="circle">
                    {{ $store.state.currentTips.length }}
                </div>
            </router-link>
        </span>
        <transition name="fade" apear>
            <div class="sub-menu" v-if="isOpen">
                <span v-for="(opt, key) in $t(`${option}.nav_options`)" :key="key">
                    <router-link v-if="opt.hasOwnProperty('href')" :to="'/' + $i18n.locale + '/' + opt.href">
                        {{ opt.title }}
                    </router-link>
                    <a v-else-if="opt.hasOwnProperty('redirect')" :href="opt.redirect" target="_blank">
                        {{ opt.title }}
                    </a>
                    <router-link v-else-if="key === 'productos_quimicos'"
                        :to="'/' + $i18n.locale + '/' + $t('enlaces.productos_quimicos')">
                        {{ opt.title }}
                    </router-link>
                    <router-link v-else :to="'/' + $i18n.locale + '/' + $t('enlaces.' + opt.category) + '/' + opt.id">
                        {{ opt.title }}
                        <div v-if="opt.alert && $store.state.currentTips.length > 0" class="circle">
                            {{ $store.state.currentTips.length }}
                        </div>
                    </router-link>
                </span>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'dropdown',
    props: ['option', 'show_dropdown'],
    data() {
        return {
            isOpen: false,
            showSubMenu: {},
            showDropdown: this.show_dropdown,
            isMobile: false,
        }
    },
    mounted() {
        if (window.innerWidth < 800) {
            this.showDropdown = false;
            this.isMobile = true;
        } else {
            this.showDropdown = true;
        }
    },
    methods: {
        toogleSubMenu: function (id) {
            this.showSubMenu[id] = !this.showSubMenu[id];
            this.isOpen = !this.isOpen;
        }
    },
    watch: {
        '$route': function () {
            delete this.showSubMenu;
            this.showSubMenu = {};
            this.isOpen = false;
        },
        show_dropdown: function () {
            this.showDropdown = this.show_dropdown;
            this.showSubMenu = {};
            this.isOpen = false;
        }
    }
}
</script>

<style scoped>
.circle {
    margin-left: 5px;
    width: 20px;
    height: 20px;
    background-color: rgb(255, 2, 2);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/parts/dropdown.vue